// Meldet global, welche scrollbaren Bereiche überwacht werden sollen - damit pull-to-refresh.js
// (auf der Host-Seite, außerhalb unseres Vue-Bundles) bei Bedarf DIREKT den aktuellen scrollTop
// abfragen kann, statt sich auf zwischengespeicherten/reaktiv gepflegten Zustand zu verlassen
// (der Ansatz über 'scroll'-Events + eigenes Set war fehleranfällig - mobiles Momentum-Scrolling
// konnte den Zustand veralten lassen, ohne dass ein 'scroll'-Event das je korrigiert hätte).
//
// Statt e.target zu inspizieren (klappt nicht zuverlässig - Shadow-DOM-Events werden beim
// Blubbern nach außen auf das Host-Element "retargeted"), melden unsere Container sich einfach
// selbst als ELEMENT-REFERENZ an - pull-to-refresh.js liest dann bei Bedarf live deren scrollTop.
//
// Anwendung: einfach v-scroll-melden auf das scrollbare Element setzen:
//   <div class="irgendein-scroll-container" v-scroll-melden>...</div>
// (Direktive lokal importieren: import { vScrollMelden } from '../lib/scrollLock.js')

if (typeof window !== 'undefined' && window.__tmScrollElemente == null) {
  window.__tmScrollElemente = new Set()
}

export const vScrollMelden = {
  mounted(el) {
    window.__tmScrollElemente.add(el)
  },
  unmounted(el) {
    window.__tmScrollElemente.delete(el)
  }
}